module.exports = __webpack_public_path__ + "img/gallery_pic8.36bdb951.jpg";